module.exports = __webpack_public_path__ + "img/zippo1.187faaff.webp";